module.exports = __webpack_public_path__ + "static/media/user-image-2.1fb5957a.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/user-image-2.png
// module id = 458
// module chunks = 0